import React from 'react'

// Local Components
import { SsoSamlConfiguration } from '../SsoSamlConfiguration'
import { SsoAttributeMappingForm } from '../SsoAttributeMappingForm'

// Types
import { WorkspaceSsoConfigFragment } from 'gqlTypes'

interface SetUpSketchProps {
  customerId: string
  isSsoEnabled: boolean
  config: WorkspaceSsoConfigFragment
}

/**
 * Renders the contents of the "Set Up Sketch" panel
 * on the Single Sign-On setup flow
 */
const SetUpSketch: React.FC<SetUpSketchProps> = ({
  customerId,
  config,
  isSsoEnabled,
}) => {
  return (
    <>
      <SsoSamlConfiguration
        customerId={customerId}
        identityProviderConfig={config?.config ?? undefined}
      />
      <SsoAttributeMappingForm
        customerId={customerId}
        attributeMapping={config?.attributeMapping ?? undefined}
        isSsoEnabled={isSsoEnabled}
      />
    </>
  )
}

export default SetUpSketch
